export let dataProps = {
    id: 0,
    template_name: '',
    subject: '',
    matter: ''
}


// WEBPACK FOOTER //
// ./src/store/modules/letterTemplate/properties.js